import React from 'react'
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { browserHistory } from 'react-router';
import NavLink from '../Routes/NavLink'
import moment from 'moment'

import { listings } from '../../core/controllers/Listings'

export default class ListingCards extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            listings: null
        };

        this.lastSortID = 0;
        this.index = 0;
    }

    componentDidMount() {
        var self = this;
        listings.getListings(this.lastSortID, function(response) {
            self.setState({listings: response.data})
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(this.lastSortID != nextProps.sortID) {
            this.lastSortID = nextProps.sortID;
            listings.getListings(this.lastSortID, function(response) {
                self.setState({listings: response.data})
            });
        }
    }

    formatIndexColumn(cell, row) {
        ++this.index;
        return this.index;
    }

    formatUnits(cell, row) {
        return (
            <span>{row.units_tally}</span>
        )
    }

    formatDate(date) {
        if(date) {
            return moment(date).format('MMMM Do YYYY');
        } else {
            return 'Not Set';
        }
    }

    editProperty() {
        browserHistory.push('/listing/' + this.details.listing_id);
    }

    render(){
        var self = this;
        var listings = this.state.listings;
        var listingCards = [];
        if(listings != null) {
            listingCards = listings.map(function(listing) {
                return (
                    <div class="property-card" style={{
                        width: "100%",
                        height: "100%",
                        display: "flex",
                        flexDirection: "column",
                    }} key={listing.details.listing_id} onClick={self.editProperty.bind(listing)}>
                        <div class="col-md-12">
                        {listing.photo == null ? (
                            <div class="property-photo">
                                <p>No property cover image.</p>
                            </div>
                        ) : (
                            <div class="property-photo">
                                <img src={listing.photo.url} width="100%" />
                            </div>
                        )}
                            <div class="property-details">
                                <div class="header">
                                    <h4 class="title">{listing.details.listing_name}</h4>
                                    <p class="category">{listing.details.listing_description}<br/>{listing.property.property_city} {listing.property.property_state}, {listing.property.property_zip}</p>
                                </div>
                                <div class="content">
                                    <div class="footer">
                                        <div class="legend">
                                        </div>
                                        <hr/>
                                        <div class="stats">
                                            <i class="fa fa-clock-o"></i> Created {self.formatDate(listing.details.created_at)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            });
        }

        return (
            <div>
                <div class="content">
                    <div class="prop-grid">
                        { listings != null ? (
                            listingCards
                        ) : (
                            <p style={{textAlign: 'center'}}>No listings found.  Try adding some.</p>
                        )}
                    </div>
                </div>
                <div class="col-md-12" style={{backgroundImage: "url('/assets/img/pluto@4x-8.png')", backgroundPosition: 'top', backgroundRepeat: 'no-repeat', backgroundSize: 'contain'}}></div>
            </div>
        )
    }
};



// WEBPACK FOOTER //
// app/components/Listings/ListingCards.jsx